@if (formGroup.get('inventoryConfig')) {
  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <pdq-heading element="h5">Product inventory</pdq-heading
        ><pdq-slide-toggle [formControl]="formGroup.get('inventoryConfig.enabled')"></pdq-slide-toggle>
      </div>
      <pdq-divider></pdq-divider>
      @if (formGroup.get('inventoryConfig.enabled').value) {
        <div class="card__content">
          <pdq-input
            label="Display text (if product variant is in stock)"
            [invalid]="!!formGroup.get('inventoryConfig.inStockPattern').errors?.missingVariables"
            [invalidMsg]="formGroup.get('inventoryConfig.inStockPattern').errors?.missingVariables"
            [formControl]="formGroup.get('inventoryConfig.inStockPattern')">
          </pdq-input>
          <pdq-input
            label="Display text (if the product variant is partially in stock)"
            [invalid]="!!formGroup.get('inventoryConfig.partiallyInStockPattern').errors?.missingVariables"
            [invalidMsg]="formGroup.get('inventoryConfig.partiallyInStockPattern').errors?.missingVariables"
            [formControl]="formGroup.get('inventoryConfig.partiallyInStockPattern')">
          </pdq-input>
          <pdq-input
            label="Display text (if product variant is out of stock)"
            [invalid]="!!formGroup.get('inventoryConfig.outOfStockPattern').errors?.missingVariables"
            [invalidMsg]="formGroup.get('inventoryConfig.outOfStockPattern').errors?.missingVariables"
            [formControl]="formGroup.get('inventoryConfig.outOfStockPattern')">
          </pdq-input>
          <pdq-input
            label="Namespace and Key of variant's metafield"
            tooltip=" Name a variant's metafield which value is number of days that the product typically ships in "
            [invalid]="!!formGroup.get('inventoryConfig.keyMetafield').errors?.emptyText"
            [invalidMsg]="formGroup.get('inventoryConfig.keyMetafield').errors?.emptyText"
            [formControl]="formGroup.get('inventoryConfig.keyMetafield')">
          </pdq-input>
          <pdq-input
            label="Fallback text"
            tooltip="Provide a fallback text in case there is no shipping options available to the customers location"
            [invalid]="!!formGroup.get('inventoryConfig.fallbackText').errors?.missingVariables"
            [invalidMsg]="formGroup.get('inventoryConfig.fallbackText').errors?.missingVariables"
            [formControl]="formGroup.get('inventoryConfig.fallbackText')">
          </pdq-input>
          <!-- Will be unhidden when more customers will use this feature -->
          <pdq-input
            [hidden]="true"
            label="Quantity input selector"
            tooltip="Name an attribute and it's value to find the quantity input on the product page"
            [invalid]="!!formGroup.get('inventoryConfig.quantityInputSelector').errors?.emptyText"
            [invalidMsg]="formGroup.get('inventoryConfig.quantityInputSelector').errors?.emptyText"
            [formControl]="formGroup.get('inventoryConfig.quantityInputSelector')">
          </pdq-input>
        </div>
      }
    </div>
  </pdq-card>
}
@if (formGroup.get('fastestShipping')) {
  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <div class="card__content">
          <pdq-heading element="h5">Fastest delivery date</pdq-heading>
          <P>Show the earliest arrival date for this product</P>
        </div>
        <pdq-slide-toggle [formControl]="formGroup.get('fastestShipping.enabled')"></pdq-slide-toggle>
      </div>
      <pdq-divider></pdq-divider>
      @if (formGroup.get('fastestShipping.enabled').value) {
        <div class="card__content">
          <div class="card__content__item">
            <pdq-checkbox [formControl]="formGroup.get('fastestShipping.hideIfLongDelivery')" label=""></pdq-checkbox>
            Don't show if arrival date is more than
            <pdq-input-arrows
              min="0"
              [formControl]="formGroup.get('fastestShipping.hideIfLongDeliveryDaysThreshold')"
              widthSize="auto"
              width="60">
            </pdq-input-arrows>
            days away
          </div>
          @if (formGroup.get('fastestShipping').errors?.longDelivery) {
            <div class="inline-error">*{{ formGroup.get('fastestShipping').errors?.longDelivery }}</div>
          }
          <div class="card__content__item">
            <pdq-checkbox
              [formControl]="formGroup.get('fastestShipping.showPrice')"
              label=""
              (onChange)="onShowPriceChanged($event)"></pdq-checkbox
            >Show shipping cost
          </div>
          <div class="card__content__item">
            <pdq-checkbox
              [formControl]="formGroup.get('fastestShipping.showCutOffTime')"
              label=""
              (onChange)="onShowCutoffChanged($event, 'fastestShipping')"></pdq-checkbox>
            <div>
              Show order cutoff timer<br />
              <small>Tell customers how long they have to order today for this delivery date</small>
            </div>
          </div>
          <pdq-input
            label="Display message"
            [invalid]="!!formGroup.get('fastestShipping').errors?.missingVariables"
            [invalidMsg]="formGroup.get('fastestShipping').errors?.missingVariables"
            [formControl]="formGroup.get('fastestShipping.pattern')">
          </pdq-input>
          <pdq-input
            label="Fallback message"
            [invalid]="!formGroup.get('fastestShipping.fallbackText').valid"
            invalidMsg="Fallback text is required"
            [formControl]="formGroup.get('fastestShipping.fallbackText')"
            placeholder="Enter fallback text"
            [tooltip]="'To ensure the PDP appears on your product pages, please add a fallback message for at least one enabled delivery type (fastest or cheapest).'">
          </pdq-input>
        </div>
      }
    </div>
  </pdq-card>
}
@if (formGroup.get('cheapestShipping')) {
  <pdq-card variant="popover" color="white">
    <div class="card">
      <div class="card__header">
        <div class="card__content">
          <pdq-heading element="h5">Cheapest delivery date</pdq-heading>
          <p>Show the arrival date for the lowest-cost shipping option</p>
        </div>
        <pdq-slide-toggle [formControl]="formGroup.get('cheapestShipping.enabled')"></pdq-slide-toggle>
      </div>
      <pdq-divider></pdq-divider>
      @if (formGroup.get('cheapestShipping.enabled').value) {
        <div class="card__content">
          <div class="card__content__item">
            <pdq-checkbox [formControl]="formGroup.get('cheapestShipping.hideIfLongDelivery')" label=""></pdq-checkbox
            >Don't show if expected delivery is more than<pdq-input-arrows
              [formControl]="formGroup.get('cheapestShipping.hideIfLongDeliveryDaysThreshold')"
              widthSize="auto"
              min="0"
              width="60"></pdq-input-arrows
            >days
          </div>
          <div class="card__content__item">
            <pdq-checkbox
              [formControl]="formGroup.get('cheapestShipping.showCutOffTime')"
              label=""
              (onChange)="onShowCutoffChanged($event, 'cheapestShipping')"></pdq-checkbox>
            <div>
              Show order cutoff timer<br />
              <small>Let customers know how long they have to get this arrival</small>
            </div>
          </div>
          <div class="card__content__item">
            <pdq-checkbox [formControl]="formGroup.get('cheapestShipping.showOnlyFreeShipping')" label=""></pdq-checkbox
            >Show only free shipping
          </div>
          @if (formGroup.get('cheapestShipping').errors?.longDelivery) {
            <div class="inline-error">*{{ formGroup.get('cheapestShipping').errors?.longDelivery }}</div>
          }
          <pdq-input-arrows
            [symbol]="shopService.shopCurrencySymbol"
            min="0"
            width="80"
            widthSize="auto"
            [formControl]="formGroup.get('cheapestShipping.cartValueThreshold')"
            label="Free shipping threshold"
            [tooltip]="'Display free shipping only if cart above the threshold'"></pdq-input-arrows>
          <pdq-input
            label="Message for free shipping"
            [invalid]="!!formGroup.get('cheapestShipping').errors?.missingVariables"
            [invalidMsg]="formGroup.get('cheapestShipping').errors?.missingVariables"
            [formControl]="formGroup.get('cheapestShipping.freeShippingPattern')"></pdq-input>
          <div>
            <pdq-input
              label="Message for cheapest shipping"
              [disabled]="formGroup.get('cheapestShipping.showOnlyFreeShipping').value"
              [invalid]="!!formGroup.get('cheapestShipping').errors?.missingCheapestPatternVariables"
              [invalidMsg]="formGroup.get('cheapestShipping').errors?.missingCheapestPatternVariables"
              [formControl]="formGroup.get('cheapestShipping.cheapestShippingPattern')"></pdq-input>
          </div>
          <mat-divider></mat-divider>
          <pdq-input
            [formControl]="formGroup.get('cheapestShipping.fallbackText')"
            [invalid]="!formGroup.get('cheapestShipping.fallbackText').valid"
            invalidMsg="Fallback text is required"
            label="Fallback message"
            placeholder="Enter fallback text"
            [tooltip]="'To ensure the PDP appears on your product pages, please add a fallback message for at least one enabled delivery type (fastest or cheapest).'"></pdq-input>
        </div>
      }
    </div>
  </pdq-card>
}
<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Customer input</pdq-heading>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card__content">
      <pdq-radio-group [formControl]="formGroup.get('addressEntry.zipOnly')">
        <pdq-radio-button
          [checked]="!formGroup.get('addressEntry.zipOnly').value"
          [value]="false"
          text="Full address"></pdq-radio-button>
        <pdq-radio-button
          [checked]="formGroup.get('addressEntry.zipOnly').value"
          [value]="true"
          text="Zip code only"></pdq-radio-button>
      </pdq-radio-group>
      <pdq-input
        [control]="formGroup.get('design.widgetTitle')"
        [formControl]="formGroup.get('design.widgetTitle')"
        label="Widget title (optional)"></pdq-input>
      <pdq-input
        [control]="formGroup.get('design.inputPlaceholder')"
        [formControl]="formGroup.get('design.inputPlaceholder')"
        label="Placeholder text"></pdq-input>
      <pdq-input
        [control]="formGroup.get('design.buttonText')"
        [formControl]="formGroup.get('design.buttonText')"
        label="Button label"></pdq-input>
      <fallback-address-input [addressControl]="formGroup.get('addressEntry.fallbackAddress')"></fallback-address-input>
      <div class="card__content__item">
        <pdq-checkbox [formControl]="formGroup.get('addressEntry.useGeolocation')" label=""> </pdq-checkbox>
        <div>Auto-detect location for guest visitors</div>
      </div>
      <pdq-input
        [control]="formGroup.get('addressEntry.errorMessage')"
        [formControl]="formGroup.get('addressEntry.errorMessage')"
        label="Error message (invalid input)"></pdq-input>
      <pdq-input-color
        [control]="formGroup.get('addressEntry.errorMessageColor')"
        [formControl]="formGroup.get('addressEntry.errorMessageColor')"
        label="Error message color"></pdq-input-color>
    </div>
  </div>
</pdq-card>
<pdq-card variant="popover" color="white">
  <div class="card">
    <div class="card__header">
      <pdq-heading element="h5">Design settings</pdq-heading
      ><pdq-checkbox
        (onChange)="onTemplateCheck($event)"
        label="Use extended design style"
        [formControl]="formGroup.get('design.zipcodeInFooterDesign')"></pdq-checkbox>
    </div>
    <pdq-divider></pdq-divider>
    <div class="card__content">
      <div class="card__content__group">
        <pdq-input-color
          [control]="formGroup.get('design.backgroundColor')"
          [formControl]="formGroup.get('design.backgroundColor')"
          label="Background"></pdq-input-color>
        <pdq-input-color
          [control]="formGroup.get('design.fontColor')"
          [formControl]="formGroup.get('design.fontColor')"
          label="Text color"></pdq-input-color>
      </div>
      <div class="card__content__group">
        <pdq-input-arrows
          widthSize="auto"
          min="0"
          [formControl]="formGroup.get('design.cornerRadius')"
          label="Corner Radius"></pdq-input-arrows
        ><pdq-input-arrows
          widthSize="auto"
          min="0"
          [formControl]="formGroup.get('design.padding')"
          label="Spacing (Padding)"></pdq-input-arrows>
        <pdq-input-arrows
          widthSize="auto"
          min="0"
          [formControl]="formGroup.get('design.buttonPadding')"
          label="Button Spacing"></pdq-input-arrows>
      </div>
      <div class="card__content__group__tight">
        <pdq-input-file
          (onPreviewChange)="iconPreviewChange.emit($event)"
          (onClearFile)="onClearIcon()"
          fileType="img"
          label="Widget icon"
          tooltip=".png, maximum size 100KB"
          variant="optionlist"
          [initialImage]="defaultIcon"
          [formControl]="formGroup.get('design.iconUrl')"></pdq-input-file>
      </div>
    </div>
  </div>
</pdq-card>
